// Utils
import axios, { endpoints } from 'src/utils/axios';

const URL = endpoints.users.root;

// ----------------------------------------------------------------------

export async function usersGetProfile() {
  const response = await axios.get(`${URL}/profile`);
  return response.data;
}

export async function usersGetByOrganization() {
  const response = await axios.get(`${URL}/by-organization`);
  return response.data;
}

export async function usersGetByID(userID, month) {
  const response = await axios.get(`${URL}/by-organization/${userID}?month=${month}`);
  return response.data;
}

export async function usersResendInvite(userID) {
  const response = await axios.post(`${URL}/by-organization/${userID}/resend-invitation`);
  return response.data;
}

export async function usersDelete(userID) {
  const response = await axios.delete(`${URL}/by-organization/${userID}`);
  return response.data;
}

export async function usersCreate(data) {
  const response = await axios.post(`${URL}/by-organization`, data);
  return response.data;
}

export async function usersUpdate(userID, data) {
  const response = await axios.put(`${URL}/by-organization/${userID}`, data);
  return response.data;
}

export async function usersUpdatePermissionSet(userID, data) {
  const response = await axios.put(`${URL}/by-organization/${userID}/permission-set`, data);
  return response.data;
}

export async function usersUpdateAvatar(userID, file) {
  const bodyFormData = new FormData();
  bodyFormData.append('file', file);
  const response = await axios.put(`${URL}/by-organization/${userID}/avatar`, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
}

export async function usersDeleteAvatar(userID) {
  const response = await axios.delete(`${URL}/by-organization/${userID}/avatar`);
  return response.data;
}
